/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface UnclosedSession {
  sessionId: string;
  recordId: string;
  punchIn: string;
  suggestedPunchOut: string;
  allowedHours: number;
}

export interface UnclosedSessionsResponse {
  success: boolean;
  data: UnclosedSession[];
}

const fetchUnclosedSessionsRequest = async (
  userId: string
): Promise<UnclosedSessionsResponse> =>
  (
    await customAxios.get<UnclosedSessionsResponse>(
      `/attendance/unclosed-sessions/${userId}`
    )
  ).data;

export const useGetUnclosedSessions = (userId?: string) =>
  useQuery<UnclosedSessionsResponse, AxiosError>(
    ["unclosedSessions", userId],
    () => {
      if (!userId)
        throw new Error("userId is required to fetch unclosed sessions");
      return fetchUnclosedSessionsRequest(userId);
    },
    {
      enabled: !!userId,
      // onError: (error) =>
      //   showNotification({
      //     // title: "Error Loading Unclosed Sessions",
      //     message: "",
      //     color: "red",
      //   }),
      retry: 1,
      refetchOnMount: "always",
      staleTime: 5 * 60 * 1000,
    }
  );
